import "./Family.css";

interface Props {
  onBack: () => void;
}

/** Plain-English privacy notice. Keep it in step with what the app actually stores. */
export function Privacy({ onBack }: Props) {
  return (
    <section className="screen family">
      <h2 className="display family-title">Privacy</h2>
      <div className="panel">
        <p>
          Nine Scrolls is a children&apos;s game. We keep as little as we can, and we never sell or
          share it.
        </p>
        <h3>Without an account</h3>
        <p>Everything stays on this device. Nothing is sent anywhere.</p>
        <h3>With a family account</h3>
        <ul>
          <li>Your email address, so you can sign in with a code.</li>
          <li>Each child&apos;s first name or nickname, settings and picture PIN.</li>
          <li>
            What they played: each trial and practice, the questions, whether they got them right,
            and how long they took.
          </li>
        </ul>
        <p>
          We don&apos;t ask for birthdays, photos, school or location, and children don&apos;t have
          emails or logins.
        </p>
        <h3>Where it&apos;s kept</h3>
        <p>
          In a Supabase database in Sydney, Australia. Only signed-in grown-ups in your family can
          see your children&apos;s data. There are no ads and no analytics or tracking.
        </p>
        <h3>Your control</h3>
        <p>
          In Parents you can export everything we hold about your family, remove a child, or delete
          your family account. Deleting removes your children, all their play and your login for
          good.
        </p>
      </div>
      <button type="button" className="big display" onClick={onBack}>
        Back
      </button>
    </section>
  );
}
